const jobs = [
    {
        slug: "senior-graphic-designer",
        title: "Senior Graphic Designer",
        category: "UI/UX",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "We are looking for a Senior Graphic Designer to shape the visual identity of our products and our clients' brands. You will work closely with product owners, engineers, and marketing to turn ideas into clear, beautiful, and consistent design across web and mobile.",
        responsibilities: [
            "Own the end-to-end design process, from concept and wireframes to polished, production-ready assets.",
            "Create and maintain brand guidelines, design systems, and reusable component libraries.",
            "Collaborate with engineers to ensure designs are implemented faithfully and perform well.",
            "Mentor junior designers and review their work with constructive, actionable feedback.",
        ],
        requirements: [
            "5+ years of professional design experience, with a strong portfolio across digital products.",
            "Expertise in Figma and the Adobe Creative Suite.",
            "A solid grasp of typography, layout, colour, and accessibility fundamentals.",
            "Clear communication skills and experience presenting design decisions to stakeholders.",
        ],
    },
    {
        slug: "senior-android-engineer",
        title: "Senior Android Engineer",
        category: "Mobile",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Join our mobile team to build Android applications used by people every day — from commerce to connected services. You will take features from idea to release and help set the technical direction of our Android practice.",
        responsibilities: [
            "Design, build, and maintain high-quality Android applications in Kotlin.",
            "Work with product owners and designers to deliver features end to end.",
            "Champion testing, CI/CD, and code review practices within the team.",
            "Mentor mid-level and junior engineers.",
        ],
        requirements: [
            "5+ years of Android development experience, with strong Kotlin skills.",
            "Deep knowledge of Android SDK, Jetpack libraries, and modern architecture patterns (MVVM/MVI).",
            "Experience shipping and maintaining apps in production at scale.",
            "Familiarity with automated testing and release pipelines.",
        ],
    },
    {
        slug: "seo-expert",
        title: "SEO Expert",
        category: "SEO",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "We are looking for an SEO Expert to grow the organic visibility of our clients' digital products. You will own strategy and execution — from technical audits to content optimisation — and measure the impact of everything you do.",
        responsibilities: [
            "Perform technical SEO audits and work with engineers to implement fixes.",
            "Develop keyword strategies and optimise on-page content.",
            "Monitor rankings, traffic, and conversions, and report clearly on results.",
            "Stay ahead of search engine algorithm changes and industry best practice.",
        ],
        requirements: [
            "3+ years of hands-on SEO experience with demonstrable results.",
            "Proficiency with tools such as Google Search Console, Analytics, Ahrefs, or SEMrush.",
            "Understanding of HTML, page performance, and structured data.",
            "Strong analytical and communication skills.",
        ],
    },
    {
        slug: "senior-ios-engineer",
        title: "Senior iOS Engineer",
        category: "Mobile",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Help us craft iOS applications that people rely on every day. As a senior engineer you will lead feature development, raise the bar on quality, and shape how we build for Apple platforms.",
        responsibilities: [
            "Design, build, and maintain iOS applications in Swift and SwiftUI.",
            "Collaborate with designers to deliver polished, accessible user experiences.",
            "Drive code quality through testing, code review, and continuous delivery.",
            "Mentor other engineers and contribute to technical decision-making.",
        ],
        requirements: [
            "5+ years of iOS development experience with strong Swift skills.",
            "Experience with SwiftUI, UIKit, and modern concurrency.",
            "A track record of shipping and supporting apps in the App Store.",
            "Familiarity with CI/CD for mobile releases.",
        ],
    },
    {
        slug: "senior-scrum-master",
        title: "Senior Scrum Master",
        category: "Agile",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "We are looking for a Senior Scrum Master to help our delivery teams do the best work of their careers. You will coach teams, remove impediments, and create the conditions for predictable, sustainable delivery.",
        responsibilities: [
            "Facilitate Scrum ceremonies and keep them focused and valuable.",
            "Coach teams, product owners, and stakeholders in agile principles.",
            "Identify and remove impediments to delivery.",
            "Track and communicate team health and delivery metrics.",
        ],
        requirements: [
            "4+ years as a Scrum Master working with software delivery teams.",
            "Certified Scrum Master (CSM/PSM) or equivalent experience.",
            "Experience scaling agile across multiple teams.",
            "Excellent facilitation and conflict-resolution skills.",
        ],
    },
    {
        slug: "senior-product-owner",
        title: "Senior Product Owner",
        category: "Agile",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "As a Senior Product Owner you will own the product backlog for one of our client engagements, turning business goals into a clear, prioritised roadmap and working daily with the delivery team to ship value.",
        responsibilities: [
            "Own and prioritise the product backlog against business outcomes.",
            "Write clear user stories with well-defined acceptance criteria.",
            "Work closely with stakeholders to align expectations and roadmaps.",
            "Measure outcomes and iterate based on data and user feedback.",
        ],
        requirements: [
            "4+ years of product ownership or product management experience.",
            "Experience working with agile software delivery teams.",
            "Strong analytical skills and comfort with product metrics.",
            "Excellent stakeholder management and communication skills.",
        ],
    },
    {
        slug: "intern-graphic-designer",
        title: "Intern Graphic Designer",
        category: "UI/UX",
        type: "Internship",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Start your design career at BEET Technologies. As a design intern you will work alongside senior designers on real client projects, learning how professional design work is scoped, created, and delivered.",
        responsibilities: [
            "Support the design team with production assets, wireframes, and prototypes.",
            "Participate in design reviews and client presentations.",
            "Learn and apply our design system and brand guidelines.",
            "Take ownership of small design tasks with guidance from a mentor.",
        ],
        requirements: [
            "A portfolio showing an eye for layout, typography, and colour — student or personal work welcome.",
            "Working knowledge of Figma or similar design tools.",
            "Curiosity, willingness to learn, and openness to feedback.",
        ],
    },
    {
        slug: "intern-android-engineer",
        title: "Intern Android Engineer",
        category: "Mobile",
        type: "Internship",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Kick-start your engineering career building real Android features that ship to real users. You will pair with senior engineers, learn our development practices, and grow quickly in a supportive team.",
        responsibilities: [
            "Build small features and fix bugs in our Android codebases under mentorship.",
            "Write tests and participate in code reviews.",
            "Learn modern Android development with Kotlin and Jetpack.",
        ],
        requirements: [
            "Foundational programming knowledge in Kotlin or Java (studies or personal projects).",
            "A genuine interest in mobile development.",
            "Eagerness to learn and good collaboration skills.",
        ],
    },
    {
        slug: "intern-ios-engineer",
        title: "Intern iOS Engineer",
        category: "Mobile",
        type: "Internship",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Learn iOS development the right way — on production apps, with experienced mentors. You will contribute code from your first weeks and build a solid foundation in Swift and Apple platform development.",
        responsibilities: [
            "Build small features and fix bugs in our iOS codebases under mentorship.",
            "Write tests and participate in code reviews.",
            "Learn Swift, SwiftUI, and our delivery workflow.",
        ],
        requirements: [
            "Foundational programming knowledge in Swift (studies or personal projects).",
            "A genuine interest in Apple platforms.",
            "Eagerness to learn and good collaboration skills.",
        ],
    },
    {
        slug: "intern-scrum-master",
        title: "Intern Scrum Master",
        category: "Agile",
        type: "Internship",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Begin your agile delivery career working alongside experienced Scrum Masters on live client engagements. You will learn facilitation, coaching, and delivery practices hands-on.",
        responsibilities: [
            "Support Scrum ceremonies and help keep team boards and metrics up to date.",
            "Shadow senior Scrum Masters and gradually take on facilitation duties.",
            "Help identify and track impediments to delivery.",
        ],
        requirements: [
            "Interest in agile ways of working and software delivery.",
            "Strong organisation and communication skills.",
            "Coursework or certification in agile/Scrum is a plus, not a must.",
        ],
    },
    {
        slug: "office-manager",
        title: "Office Manager",
        category: "Management",
        type: "Full-time",
        location: "Wolverhampton, UK — On-site",
        summary: "Keep our Wolverhampton hub running smoothly. As Office Manager you will look after the day-to-day operations of the office, support the team, and be the friendly first point of contact for visitors and suppliers.",
        responsibilities: [
            "Manage office operations, supplies, and supplier relationships.",
            "Support onboarding, travel arrangements, and company events.",
            "Assist leadership with scheduling and administrative tasks.",
            "Help maintain a welcoming, well-organised workplace.",
        ],
        requirements: [
            "2+ years of office management or administrative experience.",
            "Excellent organisation and multitasking skills.",
            "Confident communicator, comfortable with modern office tools.",
        ],
    },
    {
        slug: "senior-java-engineer",
        title: "Senior Java Engineer",
        category: "Backend",
        type: "Full-time",
        location: "Wolverhampton (UK) · Malmö (Sweden) · Accra (Ghana) — Hybrid",
        summary: "Build the backend services that power our clients' products. As a Senior Java Engineer you will design and deliver reliable, scalable services and help shape our backend engineering standards.",
        responsibilities: [
            "Design, build, and operate backend services in Java and Spring Boot.",
            "Own solutions end to end: architecture, implementation, testing, and deployment.",
            "Collaborate with frontend and mobile teams on well-designed APIs.",
            "Mentor other engineers and lead by example in code quality.",
        ],
        requirements: [
            "5+ years of backend development experience with Java.",
            "Strong knowledge of Spring, relational databases, and REST API design.",
            "Experience with cloud platforms (AWS, Azure, or GCP) and CI/CD.",
            "A pragmatic approach to architecture, testing, and observability.",
        ],
    },
]

export default jobs
